import React, { useLayoutEffect } from 'react';

import { useDispatch } from 'react-redux';
import { Route, Routes } from 'react-router-dom';

import { FilterRouter } from 'components/FilterView';
import { AllVulnerabilities } from 'containers/Visibility/Vulnerabilities/AllVulnerabilities';
import { ResourceVulnerabilityPage } from 'containers/Visibility/Vulnerabilities/Components/ResourceVulnerabilities/ResourceVulnerabilityPage';
import { useInjector } from 'utils/inject';

import { vulnerabilitySaga } from './saga';
import { reducer, sliceKey } from './slice';
import { actions } from './slice';

interface Props {
  useVulnerabilityV3?: boolean;
}

export const Vulnerabilities: React.FC<Props> = ({
  useVulnerabilityV3 = false,
}) => {
  useInjector(sliceKey, reducer, vulnerabilitySaga);
  const dispatch = useDispatch();

  useLayoutEffect(() => {
    dispatch(actions.setUseVulnerabilityV3(useVulnerabilityV3));
  }, [dispatch, useVulnerabilityV3]);

  return (
    <Routes>
      <Route
        element={<FilterRouter path="/visibility/vulnerability/resource/:id" />}
      >
        <Route path="resource/:id" element={<ResourceVulnerabilityPage />} />
      </Route>
      <Route element={<FilterRouter path="/visibility/vulnerability" />}>
        <Route
          index
          element={
            <AllVulnerabilities useVulnerabilityV3={useVulnerabilityV3} />
          }
        />
      </Route>
    </Routes>
  );
};
